import { useBjelinTranslations } from "../../../hooks/TranslationHooks";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import FieldError from "./FieldError";
import FieldRequired from "./FieldRequired";

const NameFields = ({
  firstName,
  firstNameCallback,
  lastName,
  lastNameCallback,
  errors,
  required
}) => {
  const t = useBjelinTranslations();
  return (
    <>
      <Row>
        <Col sm={6}>
          <FormGroup>
            <Label>
              {t("first.name")}
              {required && <FieldRequired />}
              <Input
                value={firstName}
                onChange={e => firstNameCallback(e.target.value)}
                type={"text"}
                placeholder={t("first.name")}
                invalid={!!errors.firstName}
              />
            </Label>
            <FieldError errors={errors} field={"firstName"} />
          </FormGroup>
        </Col>
        <Col sm={6}>
          <FormGroup>
            <Label>
              {t("last.name")}
              {required && <FieldRequired />}
              <Input
                value={lastName}
                onChange={e => lastNameCallback(e.target.value)}
                type={"text"}
                placeholder={t("last.name")}
                invalid={!!errors.lastName}
              />
            </Label>
            <FieldError errors={errors} field={"lastName"} />
          </FormGroup>
        </Col>
      </Row>
    </>
  );
};

export default NameFields;
